










import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import IdrLeftNav from "../../components/left-nav.vue";
import TongueContent from "./tongue-content.vue";
@Component({
  components: {
    MainHeader,
    IdrLeftNav,
    TongueContent,
  },
})
export default class IdrTongueList extends Vue {}
